import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgLightbulbGlyphSecondary from './svgs/LightbulbGlyphSecondary.js';
import SvgLightbulbGlyph from './svgs/LightbulbGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var lightbulbGlyph = (props => useIcon(SvgLightbulbGlyph, SvgLightbulbGlyphSecondary, props));

export { lightbulbGlyph as default };
